// Small helper for GA4 event tracking
// Safely fires gtag events; no-op if GA is not loaded (dev / blocked).

export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (_) {
    // swallow
  }
};

export const openWhatsApp = (url, source = 'unknown') => {
  trackEvent('whatsapp_click', { source, url });
  window.open(url, '_blank');
};
